import React, { useState } from "react";

import { useVACPriceBreakdownSelector } from "@redux/reducers/deal";
import { useIsCashJourneySelected } from "@hooks/useIsCashJourneySelected";
import Typography from "@components/shared/Typography";
import FinanceTerms from "@components/shared/FinanceTerms";

const FinancialPanel = () => {
  const [isFinanceTermsOpen, setIsFinanceTermsOpen] = useState(false);

  const isCashJourneySelected = useIsCashJourneySelected();
  const vacPriceBreakdown = useVACPriceBreakdownSelector();

  const teaser = vacPriceBreakdown?.vehicleSimulation?.result.teaser;
  const lines = isCashJourneySelected
    ? []
    : teaser?.textConditions?.regularPaymentConditions || [];

  const noLines = !lines || lines.length === 0;

  if (noLines) {
    return null;
  }

  return (
    <>
      <div className="w-full max-w-pageContent m-auto px-2 md:px-8 my-8">
        <div className="w-full max-w-pageContent bg-primaryDark rounded-md px-4 py-2">
          {lines.map((l, i) => (
            <Typography className="text-xs text-primaryLight" key={`line-${i}`}>
              * {l.text}{" "}
              <button
                className="text-brightOrange cursor-pointer hover:text-primaryOrange"
                onClick={() => setIsFinanceTermsOpen(true)}
                type="button"
              >
                {l.detailOpenText}
              </button>
            </Typography>
          ))}
        </div>
      </div>
      <FinanceTerms
        isOpen={isFinanceTermsOpen}
        onClose={() => setIsFinanceTermsOpen(false)}
      />
    </>
  );
};

FinancialPanel.propTypes = {};

export default FinancialPanel;
